"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetcher;

var _util = require("../util");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const STATUS_MAP = {
  '400': 'Bad Request',
  '401': 'Unauthorized',
  '402': 'Payment Required',
  '403': 'Forbidden',
  '404': 'Not Found',
  '405': 'Method Not Allowed',
  '406': 'Not Acceptable',
  '408': 'Request Timeout',
  '410': 'Resources Gone',
  '422': 'Unprocessable Entity',
  '500': 'Internal Server Error',
  '501': 'Not Implemented',
  '502': 'Bad Gateway',
  '503': 'Service Unavailable',
  '504': 'Gateway Timeout',
  '505': 'HTTP Version Not Supported'
};
const defaultConfig = {
  fetchError: '请求异常，请稍后再试。',
  parseError: '数据解析异常'
};
/**
 * ajax fetch method
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
 *
 * @param {string} api 接口 URL
 * @param {object} options
 * @param {object} [options.data] request params or send data
 * @param {object} [options.payload] only used in POST/PUT method
 * @param {'GET'|'PUT'|'POST'|'DELETE'|'HEAD'} [options.method='GET'] GET, PUT, POST, DELETE, HEAD
 * @param {object} [options.headers] request headers
 * @param {RequestCredentials} [options.credentials] credentials options
 * @param {boolean} [options.holdEmptyParam=false]
 * @param {string} [options.fetchErrorMessge]
 * @param {function} [options.responseCallback] 返回的数据处理，如果不传，默认按 ajax 方式处理
 * @return {Promise}
 */

async function fetcher(api, options, responseCallback) {
  options = _objectSpread({
    method: (options.method || 'GET').toUpperCase(),
    headers: options.headers || {}
  }, options); // POST, PUT

  const isSender = !options.method.indexOf('P'); // 用于 POST 或 PUT 请求中既有 data, 又有 payload 时，data 作为 search

  const search = options.search || (!isSender || options.payload ? options.data : null);

  if (isSender) {
    // PUT, POST
    const payload = options.payload || options.data;
    const isFormData = payload instanceof FormData;
    options.body = payload;
    options.headers = _objectSpread({}, options.headers);

    if (!isFormData) {
      options.body = typeof payload === 'string' ? payload : JSON.stringify(payload);
      options.headers['Content-Type'] = 'application/json;charset=utf-8';
    } else {
      options.headers['Content-Type'] = 'multipart/form-data';
    }
  } // 只保留 fetch 需要的参数


  const {
    data,
    payload,
    holdEmptyParam,
    fetchErrorMessge
  } = options,
        fetchProps = _objectWithoutProperties(options, ["data", "payload", "holdEmptyParam", "fetchErrorMessge"]);

  const connector = options.api.indexOf('?') > 0 ? '&' : '?';
  const url = search ? "".concat(api).concat(connector).concat((0, _util.serialize)(search, holdEmptyParam)) : api;
  const res = await fetch(url, fetchProps).catch(error => {
    console.warn('ERROR in fetch: ', error);
    throw new Error(fetchErrorMessge || defaultConfig.fetchError);
  });

  if (res.status < 200 || res.status > 399) {
    throw new Error(res.statusText || STATUS_MAP[res.status] || "Fetch Error: ".concat(res.status));
  } // 如果有自定义的处理方式，则直接调用


  if (typeof responseCallback === 'function') {
    return responseCallback(res, options);
  }

  return await res.json().catch(error => {
    console.warn('ERROR in res.json(): ', error);
    throw new Error(fetchErrorMessge || defaultConfig.parseError);
  });
}
/**
 * @param {object} [config]
 * @param {string} [config.fetchError]
 * @param {string} [config.parseError]
 */


fetcher.init = function (config) {
  Object.assign(defaultConfig, config || {});
  fetcher.hasInit = true;
};